/**
 * OfflineIndicator Component
 *
 * Displays a banner at the top of the screen when the user is offline.
 * Automatically shows when the browser goes offline and hides when back online.
 */

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './common.css';

export function OfflineIndicator() {
  const { t } = useTranslation('common');
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) {
    return null;
  }

  return (
    <div className="offline-indicator" role="alert" aria-live="assertive">
      <div className="offline-indicator-content">
        <span className="offline-icon">📡</span>
        <span className="offline-message">
          {t('offline')}
        </span>
      </div>
    </div>
  );
}

export default OfflineIndicator;
